import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Button, EditContainer, Flex, MainHeadline, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { InventoryIssueModal } from './InventoryIssueModal'
import { clearInventoryIssues, getInventoryIssues } from 'features/inventory/inventoryIssuesSlice'
import { IGetAllInventoryIssuesSingleResponse } from 'types/api/inventoryReceiptsApi.interface'
import { ViewInventoryIssueModal } from './ViewInventoryIssueModal'
import { ArrowLeft } from 'assets/icons/ArrowLeft'

export const InventoryIssues = () => {
    const { issues, totalPages } = useSelector((store: RootState) => store.inventoryIssues)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState(false)
    const [viewModal, setViewModal] = useState<{ open: boolean, value: IGetAllInventoryIssuesSingleResponse }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getInventoryIssues], cleanUpFunctions: [clearInventoryIssues], params })

    const columns: IHonestTableColumn<any>[] = [
        { id: 'date', header: 'DATE', cell: (item) => formatDateForDisplay(item.date, true) },
        { id: 'performedBy', header: 'PERFORMED BY', cell: (item) => (item.performedByUser ? (item.performedByUser.firstName + ' ' + item.performedByUser.lastName) : '/') },
        { id: 'assignedEmployee', header: 'ASSIGNED EMPLOYEE', cell: (item) => (item.assignedForUser ? (item.assignedForUser.firstName + ' ' + item.assignedForUser.lastName) : '/') },
        { id: 'fromLocation', header: 'FROM LOCATION', cell: (item) => (item.fromLocation ? item.fromLocation.name : '/') },
        { id: 'items', header: 'ITEMS', cell: (item) => item.lines.length || '/' },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <EditContainer onClick={() => setViewModal({ open: true, value: item })} >
                        <Flex style={{ transform: 'rotate(180deg)' }} className='arrow-table' >
                            <ArrowLeft />
                        </Flex>
                    </EditContainer>
                </span>
            ),
        },
    ]

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Inventory Issues</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => setModal(true)} >
                        Add Issue
                    </Button>
                </Flex>

            </Flex>
            {!issues.length ? (
                <NoItems title='Issues' />
            ) : (
                <HonestTable
                    columns={columns}
                    data={issues}
                    keyField='id'
                    onClick={(item) => setViewModal({ open: true, value: item })}
                />
            )}
            {modal && <InventoryIssueModal closeModal={() => setModal(false)} />}
            {viewModal.open && <ViewInventoryIssueModal value={viewModal.value} closeModal={() => setViewModal({ value: null, open: false })} />}

        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}